import React from 'react';
import { HeroSection } from './components/HeroSection';
import { MetricsTestimonialsSection } from './components/MetricsTestimonialsSection';
import { ExtendedTestimonialsSection } from './components/ExtendedTestimonialsSection';
import { PainSection } from './components/PainSection';
import { TransitionHookSection } from './components/TransitionHookSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="font-sans text-white bg-megapack-bg min-h-screen selection:bg-megapack-cyan selection:text-megapack-bg" data-id="element-0">
      <HeroSection data-id="element-1" />
      <MetricsTestimonialsSection data-id="element-2" />
      <ExtendedTestimonialsSection isInitial={true} data-id="element-3" />
      <PainSection data-id="element-4" />
      <TransitionHookSection data-id="element-5" />
      <ProductIntroSection data-id="element-6" />
      <ModulesSection data-id="element-7" />
      <BonusesSection data-id="element-8" />
      <UrgencySection data-id="element-9" />
      <PriceSection data-id="element-10" />
      <ExtendedTestimonialsSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FaqSection data-id="element-13" />
      <ComparisonSection data-id="element-14" />
      <FinalCtaSection data-id="element-15" />
      <FooterSection data-id="element-16" />
    </div>;
}